const state = {
    headers: {
        asset: [
            { text: '썸네일', value: 'image' },
            { text: '파일 이름', value: 'name' },
            { text: '그룹', value: 'groupData' },
            { text: '보안', value: 'secure' },
            { text: '재생 시간', value: 'runtime', solrtable:false },
            { text: '원본 해상도', value: 'upload_resolution' },
            { text: '인코딩', value: 'status' },
            { text: 'social.history.tab.social_upload', value: 'social_upload', solrtable:false, class: 'no-sort' },
            { text: 'tag', value: 'tagData', align : ' d-none' },
        ],
        playlist: [
            { text: '썸네일', value: 'image' },
            { text: '파일 이름', value: 'name' },
            { text: '그룹', value: 'groupNames' },
            { text: '재생 시간', value: 'runtime' },
        ],
        assetGroup: [
            { text: '그룹명', value: 'group_name' },
        ],
        encodeTable: [
            { text: '파일명', value: 'r_name' },
            { text: '원해상도', value: 'upload_resolution',align: 'center'  },
            { text: '가로/세로', value: 'upload_direction',align: 'center'  },
            { text: '프레임', value: 'upload_frames',align: 'center'  },
            { text: '비트레이트', value: 'upload_bitrate',align: 'center' },
        ],
        reqEncodeTable: [
            { text: '파일명', value: 'assetData.r_name' },
            { text: '대상해상도', value: 'assetData.selResolution' },
            { text: '가로/세로', value: 'assetData.upload_direction' },
            { text: '프레임', value: 'fps' },
            { text: '비트레이트', value: 'crf' },
            { text: '음질', value: 'audio' },
            { text: '속도', value: 'preset' }, 
        ],
        recordTable: [
            { text: 'Stream Name', value: 'displayStreamName' },
            { text: 'File Name', value: 'record_filename' },
            { text: 'Recoding Starttime', value: 'record_starttime' },
            { text: 'Recoding Endtime', value: 'record_endtime' },
        ],
        recordWebRTCTable: [
            { text: 'Stream Name', value: 'displayStreamName' },
            { text: 'File Name', value: 'outputFilePath' },
            { text: "Recoding Time", value: "lastModified" },
            { text: "Size", value: "size" },
            // // { text: 'Recoding state', value: 'state' },
            // { text: 'Recoding Starttime', value: 'startTime' },
            // { text: 'Recoding Endtime', value: 'finishTime' },

            // { text: "Stream Name", value: "Key" },
            // { text: 'File Name', value: 'outputFilePath' },
            // { text: "Recoding Time", value: "LastModified" },
            // { text: "Size", value: "Size" },
            // // { text: "플레이/다운로드/삭제", value: "actions", sortable: false },
        ],
        usageTable: [
            { text: "Service", value: "service" },
            { text: "Date", value: "date" },
            { text: "Value", value: "value" },
        ],
    },

    standardVal: {
        checkData: ['1080p', '720p', '480p'],
        fixedData: {
            '1080p': { 가로: '1920x1080', 세로: '1080x1920' },
            '720p': { 가로: '1280x720', 세로: '720x1280' },
            '480p': { 가로: '840x480', 세로: '480x840' },
        },
       privacyData: ['public', 'private', 'unlisted'],
    //    youtubeCat: ['게임', '과학기술', '교육', '노하우/스타일', '뉴스/정치', '비영리/사회운동', '스포츠', '애완동물/동물', '엔터테인먼트', '여행/이벤트', 
    //    '영화/애니메이션', '음악', '인물/블로그', '자동차/교통', '코미디'],
        youtubeCat: ['영화', '자동차', '음악', '동물', '스포츠', '여행/이벤트', '게임', '애완동물/동물', '인물/블로그', '코믹/유머', 
        '엔터테인먼트', '뉴스/정치', '노하우/스타일', '교육', '과학기술', '비영리/사회운동'],

       /*
            유튜브 비디오 카테고리 설정
            1:영화, 2:자동차, 10:음악, 15:동물, 17:스포츠, 19:여행/이벤트, 20:게임, 
            22:인물/블로그, 23:코믹/유머, 24:엔터테인먼트, 25:뉴스/정치, 26:노하우/스타일, 
            27:교육, 28:과학기술, 29:비영리/사회운동
        */
       /*    // Video Category List    
            1: Film & Animation,        2: Autos & Vehicles,        10: Music,              
            15: Pets & Animals,     17: Sports,    18: Short Movies,           
            19: Travel & Events,        20: Gaming,             21: VideoBlogging,      
            22: People & Blogs,    23: Comedy,                 24: Entertainment,          
            25: News & Politics,    26: Howto & Style,      27: Education,    
            28: Science & Technology,   29: Nonprofits & Activism,  30: Movies,             
            31: Anime/Animation,    32: Action/Adventure,    33: Classics,               
            34: Comedy,                 35: Documentary,        36: Drama,              
            37: Family,    38: Foreign,                39: Horror,                 
            40: Sci-Fi/Fantasy,     41: Thriller,           42: Shorts,    
            43: Shows,                  44: Trailers 
       */

    },
};

const mutations = {
 
};

const actions = {
   
};

const getters = {
    getHeaders: (state, getters, rootState, rootGetters) => key => {
        const headers = state.headers[key] || [];
        // 번역 함수가 있으면 각 헤더의 text를 번역
        if (typeof rootGetters.t === 'function') {
            return headers.map(header => ({
                ...header,
                text: rootGetters.t(header.text)
            }));
        }
        return headers;
    },
    getStandard: state => key => {
        return state.standardVal[key] || [];
    },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
